module.exports = __webpack_public_path__ + "img/BRCA1_Mast.5ceaa817.png";